import { USER } from '../constant/actionTypes';

const getUsersList = (state, action) => {
  switch (action.type) {
    case USER.GET.INITIATE:
      return { isFetching: true, data: action.payload };
    case USER.GET.SUCCESS:
      return { isFetching: false, data: action.payload };
    case USER.GET.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return (typeof state === 'undefined') ? {} : state;
  }
};

export default getUsersList;
